import slice from './reducer';

export default slice.reducer;
export * from './reducer';
export * from './thunks';
export * from './types';
export * from './utils';
